<template>
	<div class="checkout-check-container">
		<div class="check-card">
			<div class="check-item-row" v-for="(check, name) in checkList" :key="name">
				<div class="check-item-header">
					<div class="check-item-main">
						<span class="check-label font-bold">{{name}}：</span>
						<div class="check-status-indicator">
							<template v-if="check.loading">
								<i class="h-icon-loading spinning"></i>
								<span class="status-text gray-color">正在校验中...</span>
							</template>
							<template v-else-if="!check.msg">
								<i class="h-icon-check green-color"></i>
								<span class="status-text green-color">检查通过</span>
							</template>
							<template v-else-if="name !== '报表检查'">
								<i class="h-icon-close red-color"></i>
								<span class="status-text red-color">{{check.msg}}</span>
								<Button v-if="name === '外币调汇' && check.canExecute" size="s" color="primary" class="revalue-btn" :loading="check.executing" @click="executeForeignCurrencyRevaluation">执行调汇</Button>
							</template>
                            <template v-else>
								<i class="h-icon-warn red-color"></i>
								<span class="status-text red-color">逻辑勾稽未通过</span>
                            </template>
						</div>
					</div>
				</div>
                
				<!-- 报表检查详情展开 -->
				<div v-if="name === '报表检查' && check.details && !check.loading" class="check-details-panel">
					<div v-for="(result, key) in check.details" :key="key" class="detail-row">
						<div class="detail-name">{{key}}</div>
						<div class="detail-result">
							<i :class="[result.pass ? 'h-icon-check green-color' : 'h-icon-close red-color']"></i>
							<span :class="[result.pass ? 'green-color' : 'red-color']" style="margin-left: 5px">
								{{ result.pass ? '正常' : '异常' }}
							</span>
						</div>
						<div v-if="!result.pass" class="detail-msg red-color">{{ result.msg }}</div>
					</div>
					<div v-if="check.msg" class="report-error-summary red-color">
						<i class="h-icon-warn"></i> {{check.msg}}
					</div>
				</div>
			</div>
		</div>

		<div class="action-footer text-center padding">
			<Button :loading="loading" @click="back" size="l">上一步</Button>
			<Button color="primary" :loading="loading" @click="invoicing" :disabled="!checked" size="l" style="width: 120px">结 账</Button>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: "Check",
		inject: ['reload'],
		props: {
			checkYear: [Number, String],
			checkMonth: [Number, String],
		},
		data() {
			return {
				loading: false,
				checkList: {
					"期初检查": {
						loading: true
					},
					"期末检查": {
						loading: true
					},
					"外币调汇": {
						loading: true,
						canExecute: false,
						executing: false,
						details: []
					},
					"报表检查": {
						loading: true,
						details: null
					},
					"断号检查": {
						loading: true
					}
				}
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			checked() {
				return Object.values(this.checkList).every(value => !value.loading && !value.msg);
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				this.$api.checkout.initialCheck({year: this.checkYear, month: this.checkMonth}).catch(() => {
					this.$set(this.checkList.期初检查, 'msg', "期初不平衡");
				}).finally(() => {
					this.$set(this.checkList.期初检查, 'loading', false);
				});

				this.$api.checkout.finalCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
					this.$set(this.checkList.期末检查, 'loading', false);
				}).catch(() => {
					this.$set(this.checkList.期末检查, 'msg', "期末不平衡");
				});

				this.$api.checkout.foreignCurrencyCheck({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.$set(this.checkList.外币调汇, 'loading', false);
					this.$set(this.checkList.外币调汇, 'canExecute', !!data.canExecute);
					this.$set(this.checkList.外币调汇, 'details', data.details || []);
					this.$set(this.checkList.外币调汇, 'msg', data.result ? '' : (data.msg || '外币调汇检查未通过'));
				}).catch(() => {
					this.$set(this.checkList.外币调汇, 'loading', false);
					this.$set(this.checkList.外币调汇, 'msg', "外币调汇检查失败");
				});

				this.$api.checkout.reportCheck({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.$set(this.checkList.报表检查, 'loading', false);
					
					const details = {};
					const keysToCheck = ["资产负债平衡校验", "利润表-资产负债表勾稽", "现金流量-资产负债勾稽", "间接法校验(三表联动)"];
					
					keysToCheck.forEach(key => {
						if (data.hasOwnProperty(key)) {
							details[key] = {
								pass: data[key],
								msg: data[key] ? '' : '核对不一致'
							};
						}
					});
					
					this.$set(this.checkList.报表检查, 'details', details);

					if (!data.result) {
						this.$set(this.checkList.报表检查, 'msg', data.msg || "报表勾稽检查失败");
					}
				}).catch(err => {
					this.$set(this.checkList.报表检查, 'loading', false);
					this.$set(this.checkList.报表检查, 'msg', "无法连接报表引擎");
				});

				this.$api.checkout.brokenCheck({year: this.checkYear, month: this.checkMonth}).finally(() => {
					this.$set(this.checkList.断号检查, 'loading', false);
				}).catch(() => {
					this.$set(this.checkList.断号检查, 'msg', "凭证号不连续");
				});
			},
			executeForeignCurrencyRevaluation() {
				this.$set(this.checkList.外币调汇, 'executing', true);
				this.$api.checkout.foreignCurrencyRevaluation({year: this.checkYear, month: this.checkMonth}).then(({data}) => {
					this.$Message.success(data.message || "期末调汇已完成");
					Object.keys(this.checkList).forEach(key => {
						this.$set(this.checkList[key], 'loading', true);
						this.$set(this.checkList[key], 'msg', '');
					});
					this.init();
				}).finally(() => {
					this.$set(this.checkList.外币调汇, 'executing', false);
				});
			},
			invoicing() {
				this.loading = true;
				this.$api.checkout.invoicing({year: this.checkYear, month: this.checkMonth}).then(() => {
					this.$Message.success("结账成功！");
					return this.$store.dispatch('init');
				}).then(() => {
					this.$router.push({name: "CheckList"}, () => {
						this.$nextTick(() => {
							this.reload && this.reload();
						});
					});
				}).finally(() => {
                    setTimeout(() => { this.loading = false; }, 500);
				});
			},
			back() {
				this.$router.back();
			}
		}
	};
</script>

<style lang="less" scoped>
	.checkout-check-container {
		width: 800px;
		margin: 40px auto;
		background: #f8f9fa;
		padding: 2px;
		border-radius: 8px;
	}

	.check-card {
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
		overflow: hidden;
	}

	.check-item-row {
		border-bottom: 1px solid #f0f0f0;
		padding: 0;
		&:last-child {
			border-bottom: none;
		}
	}

	.check-item-header {
		padding: 20px 24px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.check-item-main {
		display: flex;
		align-items: center;
		flex: 1;
	}

	.check-label {
		font-size: 16px;
		color: #333;
		width: 140px;
	}

	.check-status-indicator {
		display: flex;
		align-items: center;
		min-height: 24px;
	}

	.status-text {
		margin-left: 8px;
		font-size: 14px;
	}

	.revalue-btn {
		margin-left: 12px;
	}

	.spinning {
		display: inline-block;
		animation: h-loading-circle 1s infinite linear;
	}

	@keyframes h-loading-circle {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}

	.check-details-panel {
		background: #fcfcfc;
		border-top: 1px dashed #eee;
		padding: 15px 24px 20px 164px;
	}

	.detail-row {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		font-size: 14px;
		&:last-child {
			margin-bottom: 5px;
		}
	}

	.detail-name {
		color: #666;
		width: 180px;
	}

	.detail-result {
		width: 80px;
		display: flex;
		align-items: center;
	}

	.detail-msg {
		flex: 1;
		font-size: 12px;
		padding-left: 15px;
	}

	.report-error-summary {
		margin-top: 15px;
		padding: 10px 15px;
		background: #fff1f0;
		border: 1px solid #ffa39e;
		border-radius: 4px;
		font-size: 13px;
	}

	.action-footer {
		margin-top: 30px;
		button {
			margin: 0 10px;
		}
	}

	.green-color { color: #52c41a; }
	.red-color { color: #f5222d; }
	.gray-color { color: #8c8c8c; }

	.padding { padding: 20px; }
</style>
